// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2kA5A","buttons":"PendingPaymentAlert_buttons__1qZm9"};